var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',{attrs:{"layout":"C"}},[_c('FtpList'),_c('SshList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }